"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggler = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _bumaga = require("../tabs/bumaga.tabs");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "classes", "itemIndex", "onChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c9b0534ab{display:inline-flex;position:relative;z-index:0}.cb49649c9{display:flex;align-items:center;flex-wrap:wrap;margin:0 -.1875rem}.c6b987b45{position:absolute;z-index:-1;border-radius:.6875rem;box-shadow:0 .0625rem .125rem rgba(0,0,0,.2);transition:all var(--animation-timing-def) ease;transition-property:top,left,width,height,background}.c6b987b45.cadcf7257{background:var(--color-flomni-blue-10)}.c6b987b45.c42d2503d{background:var(--color-flomni-green-10)}");
var styles = {
  root: 'c9b0534ab',
  children: 'cb49649c9',
  bg: 'c6b987b45',
  '--view-action': 'cadcf7257',
  '--view-success': 'c42d2503d'
};

var Toggler = function Toggler(props) {
  var children = props.children,
      classes = props.classes,
      itemIndex = props.itemIndex,
      onChange = props.onChange,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var childrenRef = (0, _react.useRef)(null);
  var bgRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!childrenRef.current || !bgRef.current) return null;
    var childrenNode = childrenRef.current;
    var bgNode = bgRef.current;

    var _childrenNode$parentN = childrenNode.parentNode.getBoundingClientRect(),
        parentTop = _childrenNode$parentN.top,
        parentLeft = _childrenNode$parentN.left;

    var _childrenNode$childre = childrenNode.children[itemIndex].getBoundingClientRect(),
        childTop = _childrenNode$childre.top,
        childLeft = _childrenNode$childre.left,
        width = _childrenNode$childre.width,
        height = _childrenNode$childre.height;

    var view = _react.Children.toArray(children)[itemIndex].props.view;

    bgNode.style.top = "".concat(childTop - parentTop, "px");
    bgNode.style.left = "".concat(childLeft - parentLeft, "px");
    bgNode.style.width = "".concat(width, "px");
    bgNode.style.height = "".concat(height, "px");
    bgNode.className = (0, _classnames.default)(cn.bg, cn.view[view]);
  }, [itemIndex, children, cn.bg, cn.view]);
  return /*#__PURE__*/_react.default.createElement(_bumaga.Tabs, (0, _extends2.default)({
    state: [itemIndex, onChange]
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.children,
    ref: childrenRef
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    ref: bgRef
  })));
};

exports.Toggler = Toggler;
Toggler.propTypes = {
  itemIndex: _propTypes.number.isRequired,
  onChange: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Toggler.defaultProps = {
  classes: {}
};